import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import imageData from "./imageData"; // Import the image data

function AllImages() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page on mount
  }, []);

  return (
    <div className="all-images-container">
      <h1>All Images</h1>
      <div className="all-images-list">
        {imageData.map((image, index) => (
          <div key={index} className="image-item">
            <img src={image.image} alt={image.name} />
            <p>{image.name}</p>
            <p>Rarity: {image.rarity}</p>
            <p>Chance: {image.chance}%</p>
          </div>
        ))}
      </div>
      {/* Back to Home button */}
      <div className="back-button-container">
        <Link to="/">
          <button className="back-button">Back to Home</button>
        </Link>
      </div>
    </div>
  );
}

export default AllImages;
